// Представление реальных пакетов песен для блока цен на лендинге. Чистые
// функции (без React/сети) — покрыты landings.test.ts. Данные — те же, что на
// /balance: fetchSongsPackagesForCurrentPlatform (shared/api/packages.ts).
import { getPackageGrantsTotal, getPackagePriceRub, } from "@/shared/api/packages";
import { isSubscriptionPackage, songsWord as songsWordByLanguage, toSubscriptionPackageView, } from "@/shared/lib/subscriptionView";
const rub = (value) => `${Math.round(value).toLocaleString("ru-RU").replace(/ /g, " ")} ₽`;
/**
 * «песня / песни / песен» по числу. Склоняет общий хелпер; обёртка с одним
 * аргументом нужна, чтобы функцию можно было передать в `.map` (второй
 * аргумент общего хелпера — язык, а `.map` подставил бы туда индекс).
 */
export const songsWord = (n) => songsWordByLanguage(n, "ru");
export const toPackageView = (pkg) => {
    const price = getPackagePriceRub(pkg);
    // Подписка: цена — за период, а не за пачку песен. «За песню» и число песен
    // без периода для неё вводят в заблуждение — показываем период и состав.
    if (isSubscriptionPackage(pkg)) {
        const view = toSubscriptionPackageView(pkg, "ru");
        return {
            id: pkg.id,
            title: pkg.title,
            price: rub(price),
            songs: "",
            perSong: "",
            isSubscription: true,
            period: view.periodShort,
            includes: view.includes,
        };
    }
    const count = getPackageGrantsTotal(pkg);
    const titleNumbers = pkg.title.match(/\d+/g) ?? [];
    return {
        id: pkg.id,
        title: pkg.title,
        price: rub(price),
        // Название пакета обычно уже говорит «10 песен» — не повторяем.
        songs: count > 0 && !titleNumbers.includes(String(count))
            ? `${count} ${songsWord(count)}`
            : "",
        perSong: count > 1 && price > 0 ? `≈ ${rub(price / count)} за песню` : "",
        isSubscription: false,
        period: "",
        includes: [],
    };
};
/**
 * id пакета с самой низкой ценой за песню — его подсвечиваем «Выгоднее всего».
 * Только когда пакетов хотя бы три и победитель однозначен: из двух пакетов
 * «выгодный» почти всегда просто самый большой, бейдж ничего не сообщает.
 * Подписки в сравнении не участвуют: их цена — за период, а не за песню.
 */
export const bestValuePackageId = (pkgs) => {
    const rated = pkgs
        .filter((p) => !isSubscriptionPackage(p))
        .map((p) => ({ id: p.id, count: getPackageGrantsTotal(p), price: getPackagePriceRub(p) }))
        .filter((p) => p.count > 0 && p.price > 0)
        .map((p) => ({ id: p.id, perSong: p.price / p.count }));
    if (rated.length < 3)
        return null;
    const sorted = [...rated].sort((a, b) => a.perSong - b.perSong);
    return sorted[0].perSong < sorted[1].perSong ? sorted[0].id : null;
};
